import reconcilePersistedState from '../../helpers/reconcilePersistedState';

const defaultState = {
  // flag for if checkout is loaded in a mode that allows loading listings dynamically
  isDynamicListing: false,

  isLoading: false,

  // persist data fetched from loading dynamic listing here so that we can re-use it in
  // app mount if the user refreshes the page after dynamically loading a listing
  eventId: null,
  listingId: null,
  listingSlug: '',
  listingInfo: {},
  uiConfig: {},
  maintenanceMode: false,
  languageParams: {},
};
const initialState = defaultState;

export function dynamicListing(state = initialState, action) {
  switch (action.type) {
    case 'SET_DYNAMIC_LISTING':
      return { ...state, isDynamicListing: !!action.data };
    case 'SET_DYNAMIC_LISTING_LOADING':
      return { ...state, isLoading: !!action.val };
    case 'SET_DYNAMIC_LISTING_ID':
      return {...state, listingId: action.val};
    case 'SET_DYNAMIC_LISTING_SLUG':
      return {...state, listingSlug: action.val};
    case 'SET_DYNAMIC_LISTING_EVENT_ID':
      return {...state, eventId: action.val};
    case 'SET_DYNAMIC_LISTING_INFO':
      return {...state, listingInfo: action.val};
    case 'SET_DYNAMIC_LISTING_UI_CONFIG':
      return {...state, uiConfig: action.val};
    case 'SET_DYNAMIC_LISTING_MAINTENANCE_MODE':
      return {...state, maintenanceMode: !!action.val};
    case 'SET_DYNAMIC_LISTING_LANGUAGE_PARAMS':
      return {...state, languageParams: action.val};
    case 'RECONCILE_PERSISTED_STATE':
      return reconcilePersistedState(state, defaultState);
    default:
      return state;
  }
}
